import PropTypes from "prop-types";
import React from "react";
import MCard from "components/Shared/MCard.tsx";

class MToolTip extends React.Component {
  constructor(props) {
    super(props);

    this.mouseListener = this.mouseListener.bind(this);
    this.getMCardProps = this.getMCardProps.bind(this);

    //there really should only ever be one tool tip rendered on the page at a time but im doing random ids just in case....
    this.toolTipId = `toolTip${parseInt(Math.random()*10000)}`;
  }

  componentDidMount() {
    document.addEventListener("mousemove", this.mouseListener);
  }

  componentWillUnmount() {
    document.removeEventListener("mousemove", this.mouseListener);
  }

  mouseListener(evt) {
    let mouseover = document.getElementById(this.toolTipId);
    let padding = 10;

    if(mouseover) {
      if(evt.clientX + mouseover.offsetWidth > document.body.offsetWidth - padding * 2)
        mouseover.style.left = (evt.clientX - padding - mouseover.offsetWidth)+"px";
      else
        mouseover.style.left = (evt.clientX + padding)+"px";

      if(evt.clientY + mouseover.offsetHeight > document.body.offsetHeight - padding * 2)
        mouseover.style.top = (evt.clientY - padding - mouseover.offsetHeight)+"px";
      else
        mouseover.style.top = (evt.clientY + padding)+"px";
    }
  }

  getMCardProps() {
    let propsWithoutVisible = {...this.props};
    delete propsWithoutVisible.visible;
    return propsWithoutVisible;
  }

  render() {
    let toolTipStyles = {
      position: "fixed",
      zIndex: 9999, //all your z-index are belong to us
      display: this.props.visible === false ? "none" : "block",
    };

    return (
      <div id={this.toolTipId} className="mtooltip" style={toolTipStyles}>
        <MCard {...this.getMCardProps()} sx={this.props.cardSx} />
      </div>
    );
  }
}

MToolTip.propTypes = {
  visible: PropTypes.bool,
  cardSx: PropTypes.object,
  //the rest of the props are passed straight to the mcard, so pass whatever mcard props you want
};

export default MToolTip;